import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { tagBackgroundColor } from '../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../web/styles/styles';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	checkboxContainer: {
		margin: `0 0 ${spacing.lg}px`,
	},
	container: {
		boxSizing: 'border-box',
		margin: `${spacing.lg}px 0`,
		overflow: 'hidden',
	},
	infoBanner: {
		alignItems: 'center',
		background: tagBackgroundColor,
		borderRadius: common.borderRadius,
		color: colors.text.main,
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: spacing.sm,
		marginBottom: spacing.md,
		padding: `${spacing.sm}px ${spacing.md}px`,
	},
	item: {
		height: 200,
		marginLeft: 15,
		marginTop: 15,
		width: 300,
	},
	items: {
		display: 'flex',
		flexWrap: 'wrap',
		marginLeft: -15,
		marginTop: -15,
	},
	metaAdsIcon: {
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'svg'
		),
	},
	textLogo: {
		color: colors.text.main,
		fontSize: typography.fontSizes.xl,
		lineHeight: 1.01,
	},
});
